export const PC_PAGE_CONFIG = {
  "name": "MetricConfig",
  "className": 'dbb-explore-metric-detail',
  "children": [
    {
      "name": 'CommonHeader',
      "config": {
        "title": {
          "name": "MetricDetailTitle",
          "config": {
            "subTitle": "For any questions, contact {{name}}.",
            "subTitleCn": "如有问题，请联系 {{name}}。"
          },
        },
        "operationList": {
          "name": 'MetricDetailOperation',
          "config": {
            "title": "Is this benchmark useful for you?",
            "titleCn": "该Benchmark对您是否有用？",
            "api": "/api/v2/dashboard/benchmark/metric/expansion/info",
            "clickApi": "/api/v2/dashboard/benchmark/metric/expansion",
            "dataKey": 'like',
          },
        }
      },
      "children": [
        {
          "name": 'CommonContantWrap',
          "config": {
            "logConfig": {
              "typeId": "benchmark_pc_console",
              "uid": "",
              "uidType": "",
              "pageId": "800303",
              "pageName": "benchmarkExplorePcConsoleMetricTips",
              "extInfo": {
                "metricKey": "{{metricKey}}",
                "metricNameEn": "{{metricNameEn}}",
                "metricNameCn": "{{metricNameCn}}",
              },
              "pagePath": "/benchmark/pcconsole/explore/metricTips",
            },
          },
          "children": [
            {
              "name": "MetricDetailTips",
              "className": "",
              "style": {},
              "props": {
                "config":
                {
                  "titleEn": "DataBrain Tips",
                  "titleCn": "DataBrain Tips"
                },
              }
            },
          ]
        }
      ]
    }
  ]
};